import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { NorthEast as OpenIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { agentChatStyles as styles } from "./styles";

// "What I did" (COMY1-391): every change of this chat the person saw a card or
// a receipt for — done, cancelled, undone, expired or failed — newest first,
// each with a link to its screen (the job's window, My Communities, Business
// Settings…). Read from GET /api/agent/actions each time it is opened.

const time = (iso, locale) =>
  iso ? new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "he-IL", { hour: "2-digit", minute: "2-digit" }).format(new Date(iso)) : "";

export default function AgentActivityFeed({ load, locale, onOpen }) {
  const { t } = useTranslation("agent");
  const [actions, setActions] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    load()
      .then((rows) => !cancelled && setActions(rows))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [load]);

  if (failed) return <Typography sx={styles.feedEmpty}>{t("feed.failed")}</Typography>;
  if (!actions) return <CircularProgress size={20} sx={{ color: "#46A091", alignSelf: "center", mt: "24px" }} />;
  if (!actions.length) return <Typography sx={styles.feedEmpty}>{t("feed.empty")}</Typography>;

  return (
    <Box component="ul" sx={styles.feed} aria-label={t("feed.title")}>
      {actions.map((a) => (
        <Box component="li" key={a.id} sx={styles.feedItem}>
          <Box sx={styles.feedHead}>
            <Box component="span" sx={styles.feedStatus(a.status)}>
              {t(`feed.status.${a.status}`)}
            </Box>
            <Typography component="span" sx={styles.feedTime}>
              {time(a.decidedAt ?? a.createdAt, locale)}
            </Typography>
          </Box>
          <Typography sx={styles.feedText} dir="auto">
            {a.status === "executed" && a.receipt
              ? a.receipt
              : a.status === "undone"
                ? a.undoReceipt ?? a.card?.title
                : a.card?.title}
          </Typography>
          {a.status === "failed" && a.error && (
            <Typography sx={styles.feedNote} dir="auto">
              {a.error}
            </Typography>
          )}
          {a.link && (
            <Button size="small" endIcon={<OpenIcon sx={styles.openIcon} />} sx={styles.feedLink} onClick={() => onOpen(a.link)}>
              {t("feed.open")}
            </Button>
          )}
        </Box>
      ))}
    </Box>
  );
}
